import type { Metadata } from "next";

/**
 * Public browser routes whose dynamic path segment is a bearer credential.
 *
 * Keep this inventory shared by page metadata, robots.txt and analytics
 * suppression. Publishing one of these URLs in a search index would publish
 * the credential itself, even when the page deliberately exposes only a
 * minimal record.
 */
export const PUBLIC_BEARER_TOKEN_PAGE_PREFIXES = [
  "/portal/",
  "/sign/",
  "/share/",
  "/shared/",
  "/crew/",
  "/site/",
  "/equipment/",
  "/team/join/",
  "/evidence/",
  "/review/",
  "/handover/",
] as const;

/** Fail closed at both the crawler and browser-referrer boundaries. */
export const BEARER_TOKEN_PAGE_METADATA: Metadata = {
  referrer: "no-referrer",
  robots: {
    index: false,
    follow: false,
    noarchive: true,
    nocache: true,
  },
};
